
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

define('component!DeleteInactiveOrganizationModalComponent',['require','translate','react','create-react-class','component!ModalComponent','component!Raw'],function (require) {
  'use strict';

  var t = require('translate');
  var React = require('react');
  var ReactCreateClass = require('create-react-class');
  var Modal = require('component!ModalComponent');
  var Raw = require('component!Raw');

  var DeleteInactiveOrganizationModalComponent = ReactCreateClass({
    displayName: 'DeleteInactiveOrganizationModalComponent',

    renderContent: function renderContent() {
      if (this.props.domain) {
        var boldDomain = '<b>' + this.props.domain + '</b>';
        return React.createElement(
          'div',
          null,
          React.createElement(
            'p',
            null,
            React.createElement(
              Raw,
              null,
              t("We automatically created a new organisation for you because you're the first person using a {0} email address on Podio. #delete-inactive-org").format(boldDomain)
            )
          ),
          React.createElement(
            'p',
            null,
            t("If you don't want this to happen, you have two choices: #delete-inactive-org")
          ),
          React.createElement(
            'ol',
            null,
            React.createElement(
              'li',
              null,
              React.createElement(
                Raw,
                null,
                t('{0} and we can move {1} to an organisation of your choice. #delete-inactive-org').format('<a href="https://docs.sharefile.com/en-us/podio" target="_blank" class="global-support-link">' + t('https://docs.sharefile.com/en-us/podio #delete-inactive-org') + '</a>', boldDomain)
              )
            ),
            React.createElement(
              'li',
              null,
              t('Simply remove the new organisation by clicking the green button below.')
            )
          )
        );
      }

      return React.createElement(
        'p',
        null,
        t('Are you sure you want to remove this organization from your sidebar? #delete-inactive-org')
      );
    },

    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      this.modal = React.createRef();
    },

    render: function render() {
      var modalProps = {
        closeOnBackdropClick: false,
        hideOnEsc: true,
        isOpen: true,
        onClose: this.props.onClose,
        showCloseButton: true
      };

      return React.createElement(
        Modal,
        _extends({ ref: this.modal, className: 'delete-inactive-organization-modal-component' }, modalProps),
        React.createElement(
          'header',
          null,
          React.createElement(
            'h1',
            { className: 'header-title' },
            t('Remove organization #delete-inactive-org')
          )
        ),
        React.createElement(
          'section',
          null,
          this.renderContent()
        ),
        React.createElement(
          'footer',
          null,
          React.createElement(
            'button',
            { className: 'button-new primary', onClick: this._handleDelete },
            t('Okay, remove it #delete-inactive-org')
          ),
          React.createElement(
            'button',
            { className: 'button-new secondary', onClick: this._handleClose },
            t('Cancel')
          )
        )
      );
    },

    _handleClose: function _handleClose(e) {
      e.stopPropagation();
      e.preventDefault();

      this.modal.current.close();
    },

    _handleDelete: function _handleDelete(e) {
      e.stopPropagation();
      e.preventDefault();

      this.props.onDelete();

      this.modal.current.close();
    }
  });

  return DeleteInactiveOrganizationModalComponent;
});
